import {
  GridComparatorFn,
  GridFilterItem,
  GridFilterOperator,
  gridStringOrNumberComparator
} from '@mui/x-data-grid-pro';
import { dateColumnOperators } from '../../Compounds/UpstackDataGrid/helpers';
import { contractEndDateSortKey, formatContractEndDate, MONTH_TO_MONTH_TERM } from '../../../utils/helpers';

export { compareContractEndDates, formatContractEndDate } from '../../../utils/helpers';

export const contractEndDateComparator: GridComparatorFn<string> = (a, b, paramsA, paramsB) =>
  gridStringOrNumberComparator(contractEndDateSortKey(a), contractEndDateSortKey(b), paramsA, paramsB);

const isMonthToMonthOperator: GridFilterOperator = {
  label: 'is Month-To-Month',
  value: 'isMonthToMonth',
  getApplyFilterFn: (filterItem: GridFilterItem) => {
    if (!filterItem.field || !filterItem.operator) {
      return null;
    }

    return (value, row): boolean => {
      return formatContractEndDate(value, row) === MONTH_TO_MONTH_TERM;
    };
  },
  InputComponent: () => null
};

export const contractEndDateFilters = (): GridFilterOperator[] => {
  return [...dateColumnOperators(), isMonthToMonthOperator];
};
